export default {
  methods: {
    formattedDate: function(timestamp) {
      let d = new Date(timestamp)
      return d.toLocaleString()
    },
  },
}
